<template>
  <!--
  跨页多选实现
  1.@selection-change="handleSelectionChange"
  2.:row-key="getRowKey"
    getRowKey(row) {
      return row.skuid;
    },
  3. <el-table-column type="selection" :reserve-selection="true" fixed="left"></el-table-column> 多选列
  4.重置的时候多选框也重置
    reset() {
      this.$refs.multipleSelection.clearSelection();
    },
 -->
  <!-- 选择询价商品 -->
  <div class="choose-products">
    <!-- <div class="search-box">
      <el-form :model="listQuery" ref="listQuery" size="small" class="search-form">
        <el-form-item label="商品名称：" label-width="92px" prop="">
          <el-input v-model="listQuery.skuname" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label-width="30px">
          <div class="search-btn">
            <div class="btn reset-btn" size="small" @click="handleReset">
              重置
            </div>
            <div class="btn submit-btn" size="small" @click="handleSearch">
              查询
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div> -->
    <!-- <div class="handle-box">
      <el-button :loading="btnLoading" @click="handleSure(null)">
        确定
      </el-button>
    </div> -->
    <div class="list-box">
      <el-table
        :data="tableData"
        ref="tableData"
        max-height="380"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
        @selection-change="handleSelectionChange"
        @select="handleSelectRowClick"
        :row-key="getRowKey"
        v-loading="tableLoading"
        tooltip-effect="dark"
      >
        <el-table-column
          type="selection"
          :selectable="selected"
          :reserve-selection="true"
          width="55px"
        ></el-table-column>
        <el-table-column
          prop="defaultImage"
          label="图片"
          fixed="left"
          width="60"
          color="#333333"
        >
          <template slot-scope="{ row }">
            <el-image
              class="default-img"
              v-if="row.imageUrl"
              :src="row.imageUrl"
              :preview-src-list="[row.imageUrl]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="skuName"
          label="商品名称"
          show-overflow-tooltip
          min-width="280"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="skuCode"
          label="商品编号"
          min-width="150"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="unitName"
          label="计量单位"
          width="80px"
          align="center"
        ></el-table-column>
        <el-table-column min-width="100px" align="center">
          <template slot="header">
            <span>市场公开价(元)</span>
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">
                市场公开价取的保供平台的市场价，如需修改价格，请在商品发布或商品维护中找到对应的商品更改可。
              </div>
              <div class="icon-question">?</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80px" align="center">
          <template slot-scope="scope">
            <el-button
              :loading="btnLoading"
              class="table-handle-btn"
              @click="handleSure([scope.row])"
              type="text"
            >
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-checkbox
        v-model="checkedAll"
        @change="checkedAllChange"
        :indeterminate="isIndeterminate"
      >
        全选
      </el-checkbox>
    </div>
    <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        layout="total, prev, pager, next"
        :current-page="listQuery.pageNum"
        :total="total"
        :page-size.sync="listQuery.pageSize"
        prev-text="上一页"
        next-text="下一页"
      ></el-pagination>
    </div>
    <div class="btn-box">
      <el-button @click="goBack('/createProduct')">上一步</el-button>
      <el-button
        class="next-btn"
        type="primary"
        v-if="tableData.length === 0"
        @click="goToUrl('/createProduct')"
      >
        返回商品发布页
      </el-button>
      <el-button
        :loading="btnLoading"
        v-else
        class="next-btn"
        type="primary"
        @click="handleSure(null)"
      >
        下一步
      </el-button>
    </div>
  </div>
</template>

<script>
import bus from '../../../../../../components/common/bus';
import api from '../../../../api/product';
export default {
  name: 'chooseProducts',
  props: {
    chooseProductsVisible: {
      type: Boolean,
      default: false,
    },
    selectProductsList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isIndeterminate: false,
      tableLoading: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        categoryId: '',
      },
      total: 0,
      tableData: [],
      idKey: 'skuid',
      multipleSelection: [],
      checkedAll: false,
      btnLoading: false,
      salesScope: '',
    };
  },
  watch: {
    checkedAll() {
      this.selected();
    },
  },
  mounted() {
    this.listQuery.categoryId = this.$getStore('categoryId');
    this.getList(this.listQuery);
    this.salesScope = this.$getStore('salesScope');
  },
  activated() {
    console.log(this.$getStore('categoryId'), 'this.$getStore("categoryId")');
    this.listQuery.categoryId = this.$getStore('categoryId');
    this.getList(this.listQuery);
    this.salesScope = this.$getStore('salesScope');
  },
  methods: {
    async getList(params) {
      try {
        this.tableLoading = true;
        const res = await api.queryByPage(params);
        this.tableLoading = false;
        this.tableData = res.data.records;
        if (this.checkedAll) {
          this.checkedAllChange();
        }
        this.total = res.data.total;
      } catch (err) {
        console.log(err);
      }
    },
    selected() {
      if (this.checkedAll) {
        return false;
      } else {
        return true;
      }
    },
    handleSelectRowClick() {
      this.checkedAll = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = [...val];
    },
    //全部勾选
    checkedAllChange() {
      if (this.checkedAll) {
        this.tableData.forEach((item) => {
          this.$refs.tableData.toggleRowSelection(item, true);
        });
      } else {
        this.$refs.tableData.clearSelection();
        this.isIndeterminate = false;
      }
    },
    typeofFn(param) {
      return Object.prototype.toString.call(param).match(/\s+(\w+)/)[1]; //正则匹配
    },
    //单个[scope.row] 批量[null] 全部
    async batchAdd(params) {
      if (params === null) {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择数据再试');
          return;
        }
      }
      this.btnLoading = true;
      const res = await api.batchAdd(params);
      this.btnLoading = false;
      if (res.code === '200') {
        this.goToUrl('/createProduct');
        // this.getList(this.listQuery);
      }
    },
    async handleSure(row) {
      let len = this.multipleSelection.length;
      if (len === 0) {
        this.$message.warning('请您选择商品数据后再提交');
        return;
      }
      if (this.checkedAll) {
        this.btnLoading = true;
        const res = await api.addAll({
          categoryId: this.listQuery.categoryId,
          salesScope: this.salesScope,
        });
        this.btnLoading = false;
        if (res.code === '200') {
          this.goToUrl('/createProduct');
          // this.getList(this.listQuery);
        }
      } else {
        // 单个的
        if (row) {
          row[0].salesScope = this.salesScope;
        } else {
          this.multipleSelection.forEach((item) => {
            item.salesScope = this.salesScope;
          });
        }
        row ? this.batchAdd(row) : this.batchAdd(this.multipleSelection);
      }
    },
    goBack() {
      this.$refs.tableData.clearSelection();
      bus.$emit('handleBack', 0);
    },
    goToUrl(url) {
      this.$router.push({
        path: url,
      });
    },
    getRowKey(row) {
      return row.skuId;
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
  },
};
</script>
<style lang="scss" scoped>
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .table-handle-btn {
    min-width: 80px;
    height: 30px;
    line-height: 30px;
    color: #0064c8;
    cursor: pointer;
    padding: 0;
    border-radius: 0;
    &:hover {
      text-decoration: underline;
    }
  }
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
::v-deep .el-image {
  width: 48px;
  height: 48px;
  display: block;
  font-size: 0;
  ::v-deep img {
    display: block;
    width: 100%;
    width: 100%;
  }
}
.search-box {
  background: #fff;
  padding: 10px;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 10px;
    margin-right: 20px;
  }
  .search-btn {
    text-align: center;
    ::v-deep .el-button {
      min-width: 80px;
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      color: #333;
      & + .el-button {
        margin-left: 30px;
        color: #fff;
      }
    }
  }
}
// 列表重置样式-结束

.choose-products {
  background: #fff;
  padding: 20px;
  .handle-box {
    white-space: nowrap;
    background: #fff;
    margin-bottom: 10px;
    min-height: 32px;
    .delete {
      color: #c5c5c5;
    }
  }
  .btn-box {
    display: flex;
    margin-top: 30px;
    justify-content: center;
  }
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }
  /* .list-box {
    max-height: 260px;
  } */

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
}
</style>
